import { useMutation } from '@tanstack/react-query';

import { api } from 'app/api';

export const postKareNotePatients = async (params) => {
  return await api.post(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/patients`, params);
};

export const deleteKareNotePatients = async (params) => {
  const { patientNumber, hspId } = params;
  return await api.post(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/karenote/patients/delete`, {
    patientNumber,
    hspId,
  });
};

export const usePostKareNotePatients = () => {
  return useMutation({
    mutationKey: 'postKareNotePatients',
    mutationFn: (params) => postKareNotePatients(params),
  });
};

export const useDeleteKareNotePatients = () => {
  return useMutation({
    mutationKey: 'deleteKareNotePatients',
    mutationFn: (params) => deleteKareNotePatients(params),
  });
};

